import { WorkspaceEmailFromAddressesRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/email/from_addresses')({
  component: WorkspaceEmailFromAddressesRoute,
});
